import { useQuery, useMutation } from '@tanstack/react-query';
import { walletService } from '../services/wallet';

export const useWallet = (userId: string | number, isB2B: boolean = false, roleId?: string | number) => {
  /**
   * Query for wallet balance
   */
  const balanceQuery = useQuery({
    queryKey: ['wallet-balance', userId, isB2B],
    queryFn: () => (isB2B ? walletService.getB2BBalance(userId) : walletService.getBalance(userId)),
    enabled: !!userId,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });

  /**
   * Query to get transactions
   */
  const useTransactions = (
    page: number = 1,
    pageSize: number = 10,
    search?: string,
    transactionType?: string,
    startDate?: string,
    endDate?: string
  ) =>
    useQuery({
      queryKey: ['wallet-transactions', userId, isB2B, page, pageSize, search, transactionType, startDate, endDate],
      queryFn: () =>
        isB2B
          ? walletService.getB2BTransactions(userId, roleId, page, pageSize, search, transactionType, startDate, endDate)
          : walletService.getTransactions(userId, page, pageSize, search, transactionType, startDate, endDate),
      enabled: !!userId,
    });

  /**
   * Mutation to get transaction detail
   */
  const transactionDetailMutation = useMutation({
    mutationFn: (transactionId: string | number) =>
      isB2B
        ? walletService.getB2BTransactionDetail(userId, transactionId, roleId)
        : walletService.getTransactionDetail(userId, transactionId),
  });

  return {
    balance: balanceQuery.data?.user_balance, // Directly return balance number
    isPostpaid: Number(balanceQuery.data?.is_postpaid ?? balanceQuery.data?.isPostpaid) === 1,
    is_postpaid: Number(balanceQuery.data?.is_postpaid ?? balanceQuery.data?.isPostpaid) || 0,
    isLoadingBalance: balanceQuery.isLoading,
    refetchBalance: balanceQuery.refetch,
    
    useTransactions,

    getTransactionDetail: transactionDetailMutation.mutateAsync,
    isFetchingDetail: transactionDetailMutation.isPending,
  };
};
